import Vue from 'vue'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import '~/assets/scss/components/multiselect.scss'

Vue.component('multiselect', Multiselect);